import React from 'react'
import Skeleton from '@mui/material/Skeleton'
import Grid from '@mui/material/Grid'

import { Avatar, Paragraph } from 'components/shared'
import { TaskData, TaskDataList, Wrapper } from '../TaskAside.style'

const LoaderAside = () => (
  <Wrapper>
    <TaskDataList>
      <TaskData>
        <label>категория</label>
        <Paragraph>
          <Skeleton variant="text" width={120} />
        </Paragraph>
      </TaskData>
      <TaskData>
        <label>Статус</label>
        <Paragraph>
          <Skeleton variant="text" width={120} />
        </Paragraph>
      </TaskData>
      <TaskData>
        <label>Клиент</label>
        <Paragraph weight={'bold'} size={'sm'}>
          <Skeleton variant="text" width={120} />
        </Paragraph>
      </TaskData>
      <TaskData>
        <label>участники</label>
        <Grid container spacing={0.5}>
          <Grid item>
            <Skeleton variant="circular" height={'auto'}>
              <Avatar size={'md'} />
            </Skeleton>
          </Grid>
          <Grid item>
            <Skeleton variant="text" width={120} />
            <Skeleton variant="text" width={60} />
          </Grid>
        </Grid>
        <Grid container spacing={0.5}>
          <Grid item>
            <Skeleton variant="circular" height={'auto'}>
              <Avatar size={'md'} />
            </Skeleton>
          </Grid>
          <Grid item>
            <Skeleton variant="text" width={120} />
            <Skeleton variant="text" width={60} />
          </Grid>
        </Grid>
      </TaskData>
      <TaskData>
        <label>Исполнитель</label>
        <Grid container spacing={0.5}>
          <Grid item>
            <Skeleton variant="circular" height={'auto'}>
              <Avatar size={'md'} />
            </Skeleton>
          </Grid>
          <Grid item>
            <Skeleton variant="text" width={120} />
            <Skeleton variant="text" width={60} />
          </Grid>
        </Grid>
      </TaskData>
    </TaskDataList>
  </Wrapper>
)

export default LoaderAside
